import { c as _c } from "react/compiler-runtime";
import { m } from 'framer-motion';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { fShortenNumber } from 'src/utils/format-number';
import { Iconify } from '../iconify';
import { varTap, varHover, transitionTap } from '../animate';

// ----------------------------------------------------------------------

export function ButtonComments(t0) {
  const $ = _c(24);
  let other;
  let sx;
  let totalComments;
  if ($[0] !== t0) {
    ({
      totalComments,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = sx;
    $[3] = totalComments;
  } else {
    other = $[1];
    sx = $[2];
    totalComments = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      textAlign: "center",
      color: "common.white",
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, .24))"
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== sx) {
    t2 = Array.isArray(sx) ? sx : [sx];
    $[5] = sx;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = [t1, ...t2];
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = varTap();
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = varHover(1.08);
    t6 = transitionTap();
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Iconify icon="solar:chat-round-dots-bold" sx={{
      width: {
        xs: 32,
        md: 26
      },
      height: {
        xs: 32,
        md: 26
      }
    }} />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== other) {
    t8 = <IconButton size="small" color="inherit" whileTap={t4} component={m.button} whileHover={t5} transition={t6} {...other}>{t7}</IconButton>;
    $[13] = other;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      typography: "caption"
    };
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== totalComments) {
    t10 = fShortenNumber(totalComments);
    $[16] = totalComments;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = <Box sx={t9}>{t10}</Box>;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t3 || $[22] !== t8) {
    t12 = <Box sx={t3}>{t8}{t11}</Box>;
    $[20] = t11;
    $[21] = t3;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}